import { SearchMaterialNumberResponseData } from 'app/cross-cutting-concerns/communication/interfaces/am-sp-api-graphql';
import { Optional } from 'lib/types/Optional';

export const getMachineClassification = (
  materialNumberInput: Optional<string>,
  materialNumberList: Optional<SearchMaterialNumberResponseData[]>
): Optional<string> =>
  materialNumberList?.find(materialNumber => materialNumber.materialNumber === materialNumberInput)?.classification;
